module.exports = __webpack_public_path__ + "img/xp_bar_pro.96c79a62.svg";